var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNexis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 155,
    height: 155,
    viewBox: "0 0 155 155",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_382_741",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 155,
    height: 155
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M139.478 0L0 15.5218L15.5218 155L155 139.478L139.478 0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_382_741)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.1776 128.307C30.3019 128.431 30.4418 128.556 30.566 128.68L35.4749 121.705C39.545 113.705 41.1296 106.403 41.1761 100.189C41.1139 96.8651 40.6478 93.5717 39.8091 90.3716C39.2187 88.4454 38.7838 86.4568 38.5041 84.4529C38.5041 84.4374 38.5041 84.4064 38.5041 84.3752C38.3177 83.0392 38.1934 81.6722 38.1314 80.3052C37.2769 58.2771 54.396 39.4027 76.3619 38.1599L76.2066 38.0202C81.4417 37.6938 89.0691 38.8435 95.4694 37.1658C102.103 35.286 108.13 31.6354 112.915 26.6022C113.148 26.3536 113.412 26.1361 113.691 25.9497L118.196 19.565C99.3375 6.48495 74.451 2.89647 51.6153 12.2327C15.7615 26.8664 -1.41971 67.8154 13.2294 103.669C16.8956 112.633 22.1928 120.431 28.6552 126.847C29.1523 127.344 29.6495 127.825 30.1621 128.307H30.1776Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.212912,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.489 31.6977C121.381 32.0239 121.256 32.3656 121.07 32.6763C116.829 40.6145 115.027 52.6072 115.415 57.3453C116.052 65.2212 118.46 70.3322 117.715 76.3596C118.274 98.2167 101.186 116.78 79.3906 117.977C79.3906 117.977 79.3596 117.977 79.3441 117.977C74.5439 118.287 73.9846 117.821 69.5885 118.023C60.5162 118.427 50.8382 122.218 44.1272 129.301L39.6377 135.686C40.9272 136.54 42.232 137.348 43.5525 138.156C44.1582 138.498 44.7641 138.824 45.3701 139.15C63.095 148.502 84.6724 150.226 104.665 142.055C140.519 127.406 157.701 86.4569 143.051 50.6031C139.043 40.801 133.063 32.3811 125.761 25.6392L121.489 31.6977Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.212912,
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNexis);
export default __webpack_public_path__ + "static/media/nexis.ddf4d1738af9484fcd42087aa8378ec8.svg";
export { ForwardRef as ReactComponent };